import Loading from '../../../Common/Loading';
import { useCausesCondictionsChartsDataContext } from './hooks/useCausesCondictionsChartsDataContext';
import { PuerperiumDeath } from './PuerperiumDeath';
import { MedicalAssistance } from './MedicalAssistance';
import { CirurgyConfirmation } from './CirurgyConfirmation';
import { ConfirmationByComplementaryExamination } from './ConfirmationByComplementaryExamination';
import { ConfirmationByNecropsy } from './ConfirmationByNecropsy';

export const Charts = () => {
    const { isLoading } = useCausesCondictionsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <PuerperiumDeath />
                <MedicalAssistance />
                <CirurgyConfirmation />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ConfirmationByComplementaryExamination />
                <ConfirmationByNecropsy />
            </div>
        </>
    );
};
